import * as d3 from 'd3'

export function formatNumber (number) {
  const s = d3.formatLocale({
    decimal: ',',
    thousands: '.',
    grouping: [3]
  })
  const f = s.format(',.0f')
  return f(number)
}
